import type { CountryType } from "../@types/generic";

export const localeMap: Record<CountryType, string> = {
    at: "de-AT",
    ch: "de-CH",
    cs: "cs-CZ",
    da: "da-DK",
    de: "de-DE",
    es: "es-ES",
    fr: "fr-FR",
    it: "it-IT",
    nl: "nl-NL",
    pl: "pl-PL",
    ro: "ro-RO",
    sk: "sk-SK",
    sv: "sv-SE",
    uk: "en-GB",
    us: "en-US",
};
